import React, { useState } from 'react';
import './App.css';

function App() {
  const [showShit, setShowShit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const playFartSound = () => {
    const audio = new Audio('/fart.mp3');
    audio.play().catch(error => {
      console.error('Error playing fart sound:', error);
    });
  };

  const playWetFartSound = () => {
    const audio = new Audio('/wetfart.mp3');
    audio.play().catch(error => {
      console.error('Error playing wet fart sound:', error);
    });
  };

  const takeAShit = async () => {
    // Play fart sound when button is clicked
    playFartSound();
    
    setIsLoading(true);
    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      // Hardcoded data instead of API call
      const responseData = {
        message: "The Mets took a shit!",
        metsLogo: "https://upload.wikimedia.org/wikipedia/en/7/7b/New_York_Mets.svg",
        poop: "💩"
      };
      setData(responseData);
      setShowShit(true);
    } catch (error) {
      console.error('Error:', error);
      setData({ message: 'Failed to take a shit. Try again later.' });
      setShowShit(true);
    } finally {
      setIsLoading(false);
    }
  };

  const takeMegaDump = async () => {
    // Play wet fart sound when mega dump button is clicked
    playWetFartSound();
    
    setIsLoading(true);
    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      // Hardcoded data instead of API call
      const responseData = {
        message: "The Mets took a shit!",
        metsLogo: "https://upload.wikimedia.org/wikipedia/en/7/7b/New_York_Mets.svg",
        poop: "💩"
      };
      setData(responseData);
      setShowShit(true);
    } catch (error) {
      console.error('Error:', error);
      setData({ message: 'Failed to take a shit. Try again later.' });
      setShowShit(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="App">
      <div className="floating-poops">
        <span className="floating-poop">💩</span>
        <span className="floating-poop">💩</span>
        <span className="floating-poop">💩</span>
        <span className="floating-poop">💩</span>
        <span className="floating-poop">💩</span>
      </div>
      <header className="App-header">
        <div className="title-container">
          <h1 className="wild-title">💩 TookAShit.com 💩</h1>
          <p className="subtitle">🚽 Track Your Daily Dumps Like a Boss! 🧻</p>
          <p className="tagline">"Because Every Shit Deserves Recognition"</p>
        </div>
        
        <div className="button-container">
          <button 
            onClick={takeAShit} 
            disabled={isLoading}
            className={`shit-button ${isLoading ? 'shaking' : ''}`}
          >
            {isLoading ? '💨 DROPPING THE KIDS OFF... 💨' : '🚀 LAUNCH THE BROWN ROCKET 🚀'}
          </button>
          
          <button 
            onClick={takeMegaDump} 
            disabled={isLoading}
            className={`shit-button mega-dump-button ${isLoading ? 'shaking' : ''}`}
          >
            {isLoading ? '💦 MEGA DUMPING... 💦' : '💥 MEGA DUMP 💥'}
          </button>
        </div>
        
        {showShit && data && (
          <div className="shit-container">
            <div className="explosion">💥 BOOM! 💥</div>
            <div className="shit-container-horizontal">
              {data.metsLogo && (
                <div className="logo-wrapper">
                  <img 
                    src={data.metsLogo} 
                    alt="Mets Logo" 
                    className="mets-logo"
                  />
                </div>
              )}
              {data.poop && (
                <div className="poop-emoji">{data.poop}</div>
              )}
            </div>
            {data.message && (
              <div className="message-wrapper">
                <p className="message-text">{data.message}</p>
                <p className="congrats">🎉 LEGENDARY DUMP! 🎉</p>
              </div>
            )}
          </div>
        )}
        
        <div className="footer-text">
          <p>🔥 Proudly Serving Shitty Content Since 2025 🔥</p>
        </div>
      </header>
    </div>
  );
}

export default App;
